export default __webpack_public_path__ + "static/media/31.4e110888.png";